const EMAIL_PATTERN = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{1,20}$/i;
const LOCATION_PATTERN = /^.*?,.*?\bUTC\b.*/;
const COMMON_STRING_PATTERN = /^[a-zA-Z0-9\s!@#$%^&*()-_=+{}[\]:;<>,.'"?\\/]*$/;
const NAME_PATTERN = /^[a-zA-Z\s-]*$/;

export const spacesValidation = (
	message: string = 'The field should have at least one letter',
) => ({
	pattern: {
		value: /.*\S.*/,
		message,
	},
});

export const requireValidationPattern = (
	value: boolean = true,
	message: string = 'This field is required',
) => ({
	required: {
		value,
		message,
	},
});

export const locationValidationPattern = (message: string = 'Enter a valid location') => ({
	pattern: {
		value: LOCATION_PATTERN,
		message,
	},
});

export const emailValidationPattern = (message: string = 'Enter a valid e-mail address') => ({
	pattern: {
		value: EMAIL_PATTERN,
		message,
	},
});

export const minLengthValidationPattern = (
	value: number = 8,
	message: string = 'Field must be at least 8 characters long',
) => ({
	minLength: {
		value,
		message,
	},
});

export const emailIsValid = (email: string) => {
	return EMAIL_PATTERN.test(email);
};

export const stringIsNotEmpty = (str: string) => {
	return !!str.trim();
};

export const companyNameValidationPattern = (message: string = 'Company name is not valid') => ({
	pattern: {
		value: COMMON_STRING_PATTERN,
		message,
	},
});

export const nameValidationPattern = (
	message: string = "Only alphabetic input space and '-' are accepted",
) => ({
	pattern: {
		value: NAME_PATTERN,
		message,
	},
});

export const nameStringIsValid = (value?: string) => {
	if (!value) return true;
	return NAME_PATTERN.test(value);
};

export const commonStringIsValid = (value?: string) => {
	if (!value) return true;
	return COMMON_STRING_PATTERN.test(value);
};

export const locationStringIsValid = (value?: string) => {
	if (!value) return true;
	return LOCATION_PATTERN.test(value);
};

export const setTextareaHeight = (
	textareaElement: HTMLTextAreaElement | null,
	wrapper: HTMLDivElement | null,
) => {
	if (!textareaElement || !wrapper) return;

	const style = getComputedStyle(textareaElement, null);
	const verticalBorders = Math.round(
		parseFloat(style.borderTopWidth) + parseFloat(style.borderBottomWidth),
	);

	const maxHeight = parseFloat(style.maxHeight) || 136;

	const newHeight = textareaElement.scrollHeight + verticalBorders;

	textareaElement.style.overflowY = newHeight > maxHeight ? 'auto' : 'hidden';
	textareaElement.style.height = Math.min(newHeight, maxHeight) + 'px';
	wrapper.style.height = Math.min(newHeight, maxHeight) + 'px';
};
